"use client"

import { Mailbox } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MailboxIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MailboxIcon = component(Icon)({ as: Mailbox })
